import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import './FlowingMenu.css';

function FlowingMenu({ items = [] }) {
    const menuWrapRef = useRef(null);
    const marqueeRef = useRef(null);
    const scrollRef = useRef(null);
    const marqueeAnimRef = useRef(null);
    const itemRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false);

    const skillsText = items.join('\u00A0\u00A0\u00A0\u00A0');

    const handleMouseEnter = () => {
        setIsHovered(true);
        if (menuWrapRef.current) {
            gsap.to(menuWrapRef.current, {
                duration: 0.6,
                ease: "power2.out",
                onStart: () => menuWrapRef.current.classList.add('expanded')
            });
        }
        
        if (scrollRef.current) {
            gsap.to(scrollRef.current, {
                timeScale: 1.5, 
                duration: 0.4,
                ease: "power2.out"
            });
        }
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
        if (menuWrapRef.current) {
            gsap.to(menuWrapRef.current, {
                duration: 0.6,
                ease: "power2.out",
                onComplete: () => menuWrapRef.current.classList.remove('expanded')
            });
        }
        
        if (scrollRef.current) {
            gsap.to(scrollRef.current, {
                timeScale: 1,
                duration: 0.4,
                ease: "power2.out"
            });
        }
    };

    useEffect(() => {
        const el = itemRef.current;
        if (!el) return;

        const repeatedText = (skillsText + '\u00A0\u00A0\u00A0\u00A0').repeat(50);
        el.textContent = repeatedText;

        gsap.set(el, { x: '0%' });

        const tl = gsap.timeline({ repeat: -1, repeatDelay: 0 });
        tl.to(el, {
            x: '-50%',
            duration: 25,
            ease: 'none',
        });

        scrollRef.current = tl;

        return () => tl.kill();
    }, [skillsText]);

    useEffect(() => {
        if (!marqueeRef.current) return;

        const repeatedText = (skillsText + '\u00A0\u00A0\u00A0\u00A0').repeat(50);
        marqueeRef.current.textContent = repeatedText;

        gsap.set(marqueeRef.current, { x: '0%' });

        const tl = gsap.timeline({ repeat: -1, repeatDelay: 0, paused: true });
        tl.to(marqueeRef.current, {
            x: '-50%',
            duration: 40,
            ease: 'none',
        });

        marqueeAnimRef.current = tl;

        if (isHovered) {
            gsap.to(marqueeRef.current.parentElement, {
                opacity: 1,
                duration: 0.4,
                ease: "power2.out"
            });
            
            gsap.to(tl, {
                timeScale: 1,
                duration: 0.4,
                ease: "power2.out",
                onStart: () => tl.play()
            });
        } else {
            gsap.to(marqueeRef.current.parentElement, {
                opacity: 0,
                duration: 0.4,
                ease: "power2.out"
            });
            
            gsap.to(tl, {
                timeScale: 0,
                duration: 0.4,
                ease: "power2.out",
                onComplete: () => tl.pause()
            });
        }

        return () => {
            if (marqueeAnimRef.current) marqueeAnimRef.current.kill();
        };
    }, [isHovered, skillsText]);

    return (
        <div 
            style={{ 
                position: 'relative', 
                height: '100%', 
                width: '100%',
                overflow: 'hidden' 
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div 
                className="background-marquee" 
                style={{ opacity: 0 }}
            >
                <div className="background-marquee-inner" ref={marqueeRef}></div>
            </div>

            <div
                className="menu-wrap"
                ref={menuWrapRef}
            >
                <nav className="menu">
                    <div className="menu__item">
                        <span
                            className="menu__item-link"
                            ref={itemRef}
                            style={{ cursor: 'default' }}
                        ></span>
                    </div>
                </nav>
            </div>
        </div>
    );
}

export default FlowingMenu;